import React, { useEffect } from 'react';

const VideoSection: React.FC = () => {
  useEffect(() => {
    // Load Wistia script
    const script = document.createElement('script');
    script.src = '//fast.wistia.com/assets/external/E-v1.js';
    script.async = true;
    document.head.appendChild(script);

    return () => {
      // Cleanup script on unmount
      const existingScript = document.querySelector('script[src*="wistia"]');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <section className="">
        <div className="w-full">
          {/* Wistia Video Embed */}
          <div className="wistia_responsive_padding" style={{ padding: '40% 0 0 0', position: 'relative' }}>
            <div className="wistia_responsive_wrapper" style={{ height: '100%', left: 0, position: 'absolute', top: 0, width: '100%' }}>
              <div className="wistia_embed wistia_async_b8ibcm6y06 videoFoam=true" style={{ height: '100%', position: 'relative', width: '100%' }}>
                <div className="wistia_swatch" style={{ height: '100%', left: 0, opacity: 0, overflow: 'hidden', position: 'absolute', top: 0, transition: 'opacity 200ms', width: '100%' }}>
                  <img src="https://fast.wistia.com/embed/medias/b8ibcm6y06/swatch" style={{ filter: 'blur(5px)', height: '100%', objectFit: 'contain', width: '100%' }} alt="" aria-hidden="true" />
                </div>
              </div>
            </div>
          </div>
        </div>
    </section>
  );
};

export default VideoSection;
